import { gql } from "@apollo/client";

export const SHOP = gql`
  query Shop($where: ShopWhereInputOne!) {
    shop(where: $where) {
      id
      name
      phone
      website
      facebookUrl
      point
      paymentType
      startDate
      endDate
      isBlocked
      isDeleted
      image
      commision
      appV2
      sp_cdc
      address {
        district
        province
        village
      }
      users {
        id
        nickname
        phone
        role
        gender
        maritualStatus
        userSub
        email
        isConfirmed
        username
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      note
      dob
      commissionService
      commissionAffiliate
      isUseInflu
      isTypeCommission
      systems
      isBillNumber
      isPaymentGateway
      exampleBill
    }
  }
`;

export const SHOP_APP_V2 = gql`
  query Shop($where: ShopWhereInputOne!) {
    shop(where: $where) {
      id
      name
      appV2
      pages{
        _id
        name
        token
        expiryDate
        createdAt
        updatedAt
        status
      }
    }
  }
`;

export const GET_SHOPS = gql`
  query Shops(
    $limit: Int
    $skip: Int
    $orderBy: SortInput
    $where: ShopWhereInput
  ) {
    shops(limit: $limit, skip: $skip, orderBy: $orderBy, where: $where) {
      data {
        id
        name
        phone
        website
        facebookUrl
        image
        coverImages
        pageId
        pageToken
        point
        money
        paymentType
        isVerified
        systems
        startDate
        endDate
        isBlocked
        isDeleted
        isUseInflu
        commision
        users {
          email
          createdAt
          id
          lastName
          firstName
        }
        createdBy
        createdAt
        updatedAt
        note
      }
      total
    }
  }
`;

export const GET_SHOP_COMMISSION_FOR_AFFILIATE = gql`
  query ShopSettingCommissionInfulancers(
    $where: ShopSettingCommissionInfulancerWhereInput
    $orderBy: OrderByInput
    $limit: Int
    $skip: Int
  ) {
    shopSettingCommissionInfulancers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      skip: $skip
    ) {
      total
      data {
        shop_name
        id
        infulancer_name
        commission
        isDeleted
        shop {
          id
          name
          phone
          commision
          isUseInflu
          isDeleted
        }
        infulancer {
          id
          first_name
          last_name
          phone
        }
      }
    }
  }
`;

export const GET_SHOP_COMMISSION_FOR_AFFILIATE_ONE = gql`
  query ShopSettingCommissionInfluencer(
    $where: ShopSettingCommissionInfulancerWhereInputOne!
  ) {
    shopSettingCommissionInfluencer(where: $where) {
      commission
      id
      infulancer_name
      shop_name
      isDeleted
      shop {
        id
        name
        phone
      }
      infulancer {
        id
        first_name
        last_name
        phone
      }
    }
  }
`;
 
